import * as React from 'react'
import { Button, Typography } from '@lacedltd/laced-components'
import { useKey } from 'react-use'
import { useTranslation } from 'hooks'
import { iconCrossM } from 'images'
import Hint from '../../Hint'
import { ConfirmationModalComponentProps } from './Modal.types'
import * as S from './Modal.styles'

const ConfirmationModal: React.FC<ConfirmationModalComponentProps> = ({
  title,
  message,
  confirmLabel,
  loading,
  error,
  onCancel,
  onConfirm
}) => {
  const { t } = useTranslation()

  useKey('Escape', onCancel)

  return (
    <S.StyledModal drawer width={440} role="presentation">
      <S.ModalBackdrop onClick={onCancel}>
        <S.ModalContent
          role="presentation"
          onClick={(e) => e.stopPropagation()}
          onTouchMove={(e) => e.stopPropagation()}
        >
          <S.ModalClose onClick={onCancel}>
            <img src={iconCrossM} alt={t('shared.close')} />
          </S.ModalClose>

          {title && <Typography.Heading as="h3">{title}</Typography.Heading>}
          {error && <Hint type="error" text={error} />}
          <Typography.Text variant="footnote">{message}</Typography.Text>

          <S.ModalActionContainer equal>
            <Button variant="secondary" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              variant="primary"
              loading={loading}
              onClick={onConfirm}
              data-testid="confirm"
            >
              {confirmLabel || t('shared.confirm')}
            </Button>
          </S.ModalActionContainer>
        </S.ModalContent>
      </S.ModalBackdrop>
    </S.StyledModal>
  )
}

export default ConfirmationModal
